<div>
  <p>Passwort zurücksetzen</p>
  <p *ngIf="resetExecuted">
    Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich
    <a routerLink="/login/login">hier</a> mit ihren neuen Zugangsdaten anmelden.
  </p>
  <p *ngIf="!resetExecuted && !isKeyLoaded">Bitte warten...</p>
  <p *ngIf="!resetExecuted && isKeyLoaded && !isKeyValid">
    Der verwendete Link zum Zurücksetzen des Passwortes ist leider nicht gültig.
    Bitte versuchen Sie es erneut.
  </p>
  <div *ngIf="!resetExecuted && isKeyLoaded && isKeyValid">
    <input
      type="password"
      autocomplete="off"
      [(ngModel)]="password1"
      #password1Input="ngModel"
      name="password1Input"
      id="password1Input"
      class="form-control"
      placeholder="Passwort"
      pattern="\s{8}\s*"
      required
      (keydown.enter)="FormAutomation.FocusNextChild($event)"
      @inOutAnimation
    />
    <input
      type="password"
      autocomplete="off"
      [(ngModel)]="password2"
      #password2Input="ngModel"
      name="password2Input"
      id="password2Input"
      class="form-control"
      placeholder="Passwort wiederholen"
      [pattern]="password1"
      required
      (keydown.enter)="FormAutomation.FocusNextChild($event)"
      @inOutAnimation
    />
    <p
      style="display: block"
      *ngIf="
        !(
          password1.length > 7 &&
          password1 == password2 &&
          hasUpperCaseCharacter() &&
          hasSpecialCharacter()
        )
      "
    >
      mind. 8 Zeichen, einen Großbuchstaben und ein Sonderzeichen
    </p>
    <button
      id="submit"
      class="btn btn-block form-control"
      [disabled]="
        !(
          password1.length > 7 &&
          password1 == password2 &&
          hasUpperCaseCharacter() &&
          hasSpecialCharacter()
        )
      "
      @inAnimation
      (click)="submit()"
    >
      Speichern
    </button>
  </div>
</div>
